import React, { useState } from 'react';
import { Typography, Button } from '@mui/material';
import '../styles/common.css';
import Confetti from 'react-confetti';
import moment from 'moment/moment';
import langDetails from '../components/MultiLanguage/language.json';

const SubscriptionSuccess = ({ sharedData, paymentId, moreProjectRedrection, exclusiveContentRedrection }) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const lang = langDetails[sharedData?.language];

  const currency = sharedData?.donationAmount?.currency?.toUpperCase();
  const currencySymbol = sharedData?.donationAmount?.currencySymbol;
  const totalAmount = sharedData?.donationAmount?.totalAmount;
  const youGive = sharedData?.donationAmount?.youGive;
  const recurringInterval = sharedData?.donationAmount?.recurringInterval;
  const projectName = sharedData?.projectName;
  const today = moment().format('MMM D, YYYY');

  const getNextBillingDate = () => {
    if (recurringInterval === 'monthly') return moment().add(1, 'month').format('MMM D, YYYY');
    if (recurringInterval === 'quarterly') return moment().add(3, 'months').format('MMM D, YYYY');
    return '';
  };

  setTimeout(() => { setShowConfetti(false); }, 10000);

  return (
    <><div style={{ textAlign: 'center', minHeight: 400, position: 'relative', top: '-24px' }}>
      {showConfetti &&
        <div style={{ position: 'relative', zIndex: 0 }}>
          <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={200} opacity={0.7} />
        </div>
      }
      <div style={{ position: 'relative' }}>
        <div>
          {/* Green tick icon */}
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 35, marginBottom: 16 }}>
            <div style={{
              width: 64, height: 64,
              borderRadius: '50%',
              backgroundColor: '#22C55E',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <svg width="32" height="32" viewBox="0 0 52 52" fill="none">
                <path d="M14 27l9 9 16-16" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
          <Typography className='big-head mb-10' style={{ color: '#111' }}>Subscription Activated!</Typography>
          <Typography className="lg-normal-text mb-20" style={{ color: '#111111BF' }}>
            Thank you for your recurring support! <br /> Your first payment has been processed successfully.
          </Typography>
        </div>

        {/* Receipt summary */}
        <div style={{ textAlign: 'left', marginBottom: 20, padding: '16px', border: '1px solid rgba(17,17,17,0.1)', borderRadius: 12 }}>
          <Typography className="sub-head-2 mb-10" style={{ color: 'rgba(17,17,17,0.5)', letterSpacing: '1px', textTransform: 'uppercase' }}>Payment Summary</Typography>

          {paymentId && (
            <div className="flex-space-btw mb-10">
              <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>{lang?.confirmationNumber}</Typography>
              <Typography className="sub-head" style={{ color: '#111' }}>{paymentId}</Typography>
            </div>
          )}
          {projectName && (
            <div className="flex-space-btw mb-10">
              <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Project</Typography>
              <Typography className="sub-head" style={{ color: '#111' }}>{projectName}</Typography>
            </div>
          )}
          <div className="flex-space-btw mb-10">
            <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Date</Typography>
            <Typography className="sub-head" style={{ color: '#111' }}>{today}</Typography>
          </div>
          <div className="flex-space-btw mb-10">
            <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Amount Charged</Typography>
            <Typography className="sub-head" style={{ color: 'rgba(93, 66, 148, 1)', textTransform: 'uppercase' }}>
              {currency} {currencySymbol}{totalAmount ? Number(totalAmount).toFixed(2) : '0.00'}
            </Typography>
          </div>
          {recurringInterval && recurringInterval !== 'one-time' && (
            <>
              <div className="flex-space-btw mb-10">
                <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Frequency</Typography>
                <Typography className="sub-head" style={{ color: 'rgba(93, 66, 148, 1)', textTransform: 'capitalize' }}>
                  {recurringInterval}
                </Typography>
              </div>
              <div className="flex-space-btw mb-10">
                <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Next Billing Date</Typography>
                <Typography className="sub-head" style={{ color: '#111' }}>{getNextBillingDate()}</Typography>
              </div>
              <div className="flex-space-btw mb-10">
                <Typography className="normal-text" style={{ color: 'rgba(17,17,17,0.5)' }}>Next Billing Amount</Typography>
                <Typography className="sub-head" style={{ color: 'rgba(93, 66, 148, 1)', textTransform: 'uppercase' }}>
                  {currency} {currencySymbol}{youGive ? Number(youGive).toFixed(2) : '0.00'}
                </Typography>
              </div>
            </>
          )}
        </div>

        <div className='btn-holder mb-10'>
          <Button className="normal-text outlined-black-btn lin-gradient" style={{ textTransform: 'capitalize', width: '100%', borderRadius: 12, backgroundColor: '#fff' }} variant='outlined' onClick={moreProjectRedrection}>
            <p className='lg-btn-text'>{lang?.moreProjects || 'More Projects'}</p>
          </Button>
          <Button className="normal-text default-btn" style={{ width: '100%' }} variant='contained' onClick={exclusiveContentRedrection}>
            <p className='lg-btn-text'>{lang?.exclusiveContent || 'Exclusive Content'}</p>
          </Button>
        </div>
      </div>
    </div></>
  );
};

export default SubscriptionSuccess;
